/**
* @template Common model declaration for storing common values
**/
export interface Common {
  errorCode: string;
  tableColumns: Array<string>;
  tableDataSource: Array<object>;
  step: string;
  getResponse: object;
  getFailedRecords: object;
  showResults: string;
  profile: string;
}
/**
* @const initialCommon State model for storing  asi capabilities and packages
**/
export const initialCommon: Common = {
  errorCode: '',
  tableColumns: [],
  tableDataSource: [{}],
  step: '',
  getResponse: {},
  getFailedRecords: {},
  showResults: 'package',
  profile: ''
};
